module.exports = __webpack_public_path__ + "6841f70565bcc978fd0fc94f0e3d00f6.png";